export default __webpack_public_path__ + "static/media/close.81279d6e.svg";